import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LimitOver.module.css';

const LimitOver = ({ message }) => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconContainer}>
          <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h1 className={styles.title}>Limit Reached</h1>
        <p className={styles.message}>
          {message || "You've reached the guest viewing limit. Please sign in or create an account to continue."}
        </p>
        <div className={styles.buttonContainer}>
          <Link to="/signin" className={`${styles.button} ${styles.loginButton}`}>
            Sign In
          </Link>
          <Link to="/signup" className={`${styles.button} ${styles.signupButton}`}>
            Create Account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LimitOver;